export default {
    data() {
      return {
        sidebar: '2',
        props: {
          'name': 'VideoComponent',
          'zIndex': 'auto',
          'paddingTop': '0px',
          'paddingLeft': '15px',
          'paddingRight': '15px',
          'paddingBottom': '15px',
          'width': '100px',
          'height': '100px',
          'minHeight': '0px',
          'maxWidth': '100px',
          secret: 'H0IJplNdvK',
          autoplay: false,
          countdown: false,
          loop: false,
          controls: false,
          'animation': {
            'in': {
              'action': 'time',   //time/scroll/click/hover
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'speed': 'slow',
              'infinite': false,
            },
            'out': {
              'action': 'time',   //time/scroll/click
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'delay': '1',
              'speed': '1',
              'infinite': false,
            },
          },
        },
        elements: [],
        internal_config: {
          'theme': '01',
          'width': '100px',
          'maxWidth': '100px',
          'height': '100px',
          'minHeight': '0px',
          'zIndex': 'auto',
          'showDesktop': true,
          'showMobile': true,
          'paddingTop': '0px',
          'paddingLeft': '15px',
          'paddingRight': '15px',
          'paddingBottom': '15px',
          left: '0px',
          top: '0px',
          secret: 'H0IJplNdvK',
          autoplay: false,
          countdown: false,
          loop: false,
          controls: false,
          'animation': {
            'in': {
              'action': 'time',   //time/scroll/click/hover
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'speed': 'slow',
              'infinite': false,
            },
            'out': {
              'action': 'time',   //time/scroll/click
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'delay': '1',
              'speed': '1',
              'infinite': false,
            },
          },
        }
      };
    }
  };



// WEBPACK FOOTER //
// ./src/components/editor/apps/Video/Model.js